import type { ReactNode } from "react";
import classNames from "classnames";

import { Box } from "@braintrust/braintrust-ui-components";

import styles from "./styles.module.scss";

type JobItemButtonsProps = {
  isTablet: boolean;
  isInvitesTab?: boolean;
  children?: ReactNode;
};

export const JobItemButtons = ({
  isTablet,
  isInvitesTab = false,
  children,
}: JobItemButtonsProps) => {
  return (
    <Box
      className={classNames(styles.wrapper, {
        [styles.invitesTab]: isTablet && isInvitesTab,
      })}
    >
      {children}
    </Box>
  );
};
